import { useEffect, useState } from "react";
// Components
import {
  CurrentPageInputField,
  GoToBackBtn,
  GoToNextBtn,
  ItemsPerPageSelector,
  MoveToFirstPageBtn,
  MoveToLastPageBtn,
} from "./components";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useDispatch } from "react-redux";
import {
  importsSummaryDataLimitAction,
  importsSummaryDataPaginationAction,
} from "store/filters/reducer.actions";
// types
import { PaginationProps, handleChangeOnCurrentPageInputField } from "./types";
import { filtersInitialState } from "store/filters/initialState";
import { IImportSummaryData } from "store/importSummary/initialState";

export const Pagination: React.FC<PaginationProps> = ({ }) => {
  const [pageInput, setPageInput] = useState("");
  const { importsSummaryDataFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const { data, totalPages } = useSelector<RootState, IImportSummaryData>(
    (state) => state?.importSummary
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setPageInput(importsSummaryDataFilter.page.toString());
  }, [importsSummaryDataFilter.page]);

  // Handlers
  const handleChangeItemsPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { value } = event.target;
    dispatch(importsSummaryDataLimitAction(parseInt(value)));
  };
  const handleClickOnMoveToFirstPageBtn = () => {
    dispatch(importsSummaryDataPaginationAction(1));
  };
  const handleClickOnGoToBackBtn = () => {
    dispatch(
      importsSummaryDataPaginationAction(
        importsSummaryDataFilter.page > 1 ? importsSummaryDataFilter.page - 1 : 1
      )
    );
  };
  const handleClickOnGoToNextBtn = () => {
    dispatch(
      importsSummaryDataPaginationAction(
        importsSummaryDataFilter.page < totalPages
          ? importsSummaryDataFilter.page + 1
          : totalPages
      )
    );
  };
  const handleClickOnMoveToLastPageBtn = () => {
    dispatch(importsSummaryDataPaginationAction(totalPages));
  };
  const handleChangeOnCurrentPageInputField: handleChangeOnCurrentPageInputField =
    (e) => {
      e.preventDefault();
      const value = e.target.value;
      setPageInput((prevValue: any) => {
        if (value === "" || !isNaN(parseInt(value))) {
          if (parseInt(value) <= totalPages && parseInt(value) > 0) {
            if (!isNaN(parseInt(value))) {
              dispatch(importsSummaryDataPaginationAction(parseInt(value)));
            } else {
              dispatch(importsSummaryDataPaginationAction(1));
            }

            return value;
          }
        }
        return "";
      });
    };

  const handleBlurOnCurrentPageInputField = () => {
    setPageInput(importsSummaryDataFilter.page.toString());
  };

  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent event from propagating to the drawer
    event.stopPropagation();
  };

  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 px-6 pt-8 pb-10 bg-white rounded-bl-lg rounded-br-lg">
      <div className="flex items-center justify-start flex-grow">

        <ItemsPerPageSelector
          handleChangeItemsPerPage={handleChangeItemsPerPage}
          limit={importsSummaryDataFilter.limit}
        />
        <div className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-2">
          <MoveToFirstPageBtn
            page={importsSummaryDataFilter.page}
            handleClickOnBtn={handleClickOnMoveToFirstPageBtn}
          />
          <CurrentPageInputField
            pageInput={pageInput}
            handleChangeOnInput={handleChangeOnCurrentPageInputField}
            handleBlurOnInput={handleBlurOnCurrentPageInputField}
            handleInputKeyDown={handleInputKeyDown}
          />
          <div className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-1 px-3 py-1 rounded-lg">
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative pt-0.5">
              <p className="flex-grow-0 flex-shrink-0 text-[15px] text-center text-textMid dark:text-caption">
                of {totalPages}
              </p>
            </div>
          </div>
          <GoToBackBtn
            page={importsSummaryDataFilter.page}
            handleClickOnBtn={handleClickOnGoToBackBtn}
          />
          <GoToNextBtn
            page={importsSummaryDataFilter.page}
            totalPages={totalPages}
            handleClickOnBtn={handleClickOnGoToNextBtn}
          />

          <MoveToLastPageBtn
            page={importsSummaryDataFilter.page}
            totalPages={totalPages}
            handleClickOnBtn={handleClickOnMoveToLastPageBtn}
          />
        </div>
      </div>
    </div>
  );
};
